import { render } from "./ProjectHistoryManager.vue?vue&type=template&id=7629cb72&scoped=true"
import script from "./ProjectHistoryManager.vue?vue&type=script&lang=js"
export * from "./ProjectHistoryManager.vue?vue&type=script&lang=js"

import "./ProjectHistoryManager.vue?vue&type=style&index=0&id=7629cb72&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7629cb72"]])

export default __exports__